import styled from 'styled-components';

export const StyledSubmitContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
`;
